import React, { useState, useEffect } from "react"
import { CardText, Col, Row, Button } from "reactstrap"
import DPTextBoxforgrid from "framework/components/DPTextBoxforgrid"
import { Text } from "../../../framework/validators/TextValidation"
import DPAlert from "framework/widgets/DPAlert"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import { loadPopupSearchPay } from "framework/validators/SearchColumn"
import ReactPaginate from "react-paginate"


const CustomerMasterTab6 = ({
  DataRow,
  disabled,
  menuCode,
  setVasRow,
  currentPageRest
}) => {

  const [alertShow, setsweetAlertShow] = useState(false)
  const [alertDesc, SetAlertDesc] = useState("")
  const [HeadColumns, setHeadColumns] = useState([])
  const [postsPerPage] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)
  const indexOfLastPost = currentPage * postsPerPage
  const indexOfFirstPost = indexOfLastPost - postsPerPage
  const currentPosts = DataRow.slice(indexOfFirstPost, indexOfLastPost);

  useEffect(() => {
    setCurrentPage(1)
  }, [currentPageRest])


  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
  };

  // add new row function
  function handleAddRowNestedVas() {
    // Check if there is any existing row with empty values
    const hasEmptyRow = DataRow.find(x => x.code == "");
    if (hasEmptyRow) {
      // If there is any row with empty values, do not add a new row
      return false;
    }

    const modifiedRows = [...DataRow]
    modifiedRows.push({
      id: modifiedRows.length + 1,
      code: "",
      //provider: "",
      providercCodeDisable: false,
      desc: "",
      account: "",

    })

    const idModification = modifiedRows.map((item, index) => {
      item.id = index + 1;
      return item
    })


    setVasRow(idModification)
  }

  /**
      * @description This function is used to change the value of particular field in particular row.
      * @param {string} value - value of the row.
      * @param {string} id - id of the row.
      * @param {string} element - element of the row.
   */

  const changeRowValueChanges = (value, id, element) => {
    const objectIndex = DataRow.findIndex(obj => obj.id === id);
    const newObject = { ...DataRow[objectIndex], [element]: value };
    setVasRow(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = newObject;
      return newDataRow;
    });
  };

  /**
    * @description This function is used to change the value of complete row.
    * @param {JSON} row - row of the table.
    * @param {string} id - id of the row.
 */

  function handleObjectChange(row, id) {
    const objectIndex = DataRow.findIndex(obj => obj.id === id);
    setVasRow(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = row;
      return newDataRow;
    });
  }

  function handleRemoveRowVas(id) {
    const modifiedRows = [...DataRow]
    const index = modifiedRows.findIndex(obj => obj.id === id)
    modifiedRows.splice(index, 1)

    if (modifiedRows.length == 0) {
      modifiedRows.push({
        id: modifiedRows.length + 1,
        code: "",
        //provider: "",
        providercCodeDisable: false,
        desc: "",
        account: "",
      })
    }

    const idModification = modifiedRows.map((item, index) => {
      item.id = index + 1;
      return item
    })

    setVasRow(idModification)
  }


  return (
    <React.Fragment>
      <div>
        <Row>
          <Col sm="12">
            <CardText className="mb-0">
              <Row>
                <DPAlert
                  confirm_both={alertShow}
                  title={"Customer Master !"}
                  description={alertDesc}
                  showCancel={false}
                  btnColor={"success"}
                  cancelColor={"danger"}
                  onConfirm={() => {
                    setsweetAlertShow(false)
                  }}
                  btnYes={"OK"}
                />
              </Row>
              <Row>
                <Col sm={12} md={12} className="mb-12-sm">
                  <table style={{ fontSize: "11px" }} id={"vasTable"} >
                    <thead className="table-light">
                      <tr>
                        <th>Provider code </th>
                        <th></th>
                        <th>Provider </th>
                        <th>Account Number</th>
                      </tr>
                    </thead>
                    <tbody disabled={true}>
                      {currentPosts.map((formRow, key) => (
                        <TableRow
                          FormRow={formRow}
                          Key={key}
                          RemoveRow={handleRemoveRowVas}
                          Disabled={disabled}
                          AlertShow={setsweetAlertShow}
                          AlertDesc={SetAlertDesc}
                          HeadColumns={HeadColumns}
                          menuCode={menuCode}
                          changeRowValueChanges={changeRowValueChanges}
                          handleObjectChange={handleObjectChange}
                          DataTable={DataRow}
                        />
                      ))}
                    </tbody>
                  </table>
                  <Row sm={12} md={12} className="mb-4-sm">
                    <Col>
                      <Button
                        onClick={() => {
                          handleAddRowNestedVas()
                        }}
                        color="success"
                        className="mt-1"
                        disabled={disabled}
                        size="sm"
                      >
                        <i className="mdi mdi-hospital" style={{ fontSize: "12px" }}></i>
                      </Button>
                    </Col>
                    <Col>
                      <ReactPaginate
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        pageCount={Math.ceil(DataRow.length / postsPerPage)}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        forcePage={currentPage - 1}
                        renderOnZeroPageCount={null}
                        activeClassName={'active'}
                        activeLinkClassName={'page-link'}
                        containerClassName={'pagination justify-content-end pagination-sm'}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </CardText>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}
export default CustomerMasterTab6



const TableRow = ({ FormRow, Key, RemoveRow, Disabled, AlertShow,
  AlertDesc, HeadColumns, menuCode, handleObjectChange, changeRowValueChanges, DataTable }) => {

  const [modal_xlarge, setmodal_xlarge] = useState(false)

  const [groupFilter, SetGroupFilter] = useState("a")
  const ApiURL = window.Links.ApiURL

  useEffect(async () => {
    getData(FormRow.provider)
  }, [FormRow.provider])

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]


  const Hed_SelectRowSearch = (e, row, isSelect, rowIndex) => {
    if (CodeValidation(row.VS_CODE, "provider" + Key)) {
      getData(row.VS_CODE)
    } else {
      AlertShow(true)
      AlertDesc("Code already used !")
    }
    setmodal_xlarge(!modal_xlarge)
  }

  function getData(searchdata) {
    const authToken = localStorage.getItem("authToken")
    if (searchdata != "") {

      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}Provider/search/${searchdata}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`
        },
      })
        .then(Response => Response.json())
        .then(responseData => {
          if (responseData.success == true) {
            const newArray = [...responseData.data]
            var currentRow = FormRow
            currentRow.code = searchdata
            currentRow.desc = newArray[0].name
            currentRow.providercCodeDisable = true;
            handleObjectChange(currentRow, FormRow.id)

          } else {
            //currentRow.providercCodeDisable = false;
            var currentRow = FormRow
            currentRow.code = ""
            currentRow.desc = ""
            handleObjectChange(currentRow, FormRow.id)
          }
        })
    }
  }

  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }

  async function clickSearch() {
    tog_xlarge();
  }


  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }
  //* Code Validation from repeating*/

  const CodeValidation = (strCode, id, key) => {

    // const hasRowwithSameAccount = DataTable.filter(x => x.code == strCode && x.id != FormRow.id)
    // if (hasRowwithSameAccount.length > 0) {
    //   return false
    // }
    return true
  }

  const AccountValidation = (strCode, id, key) => {

    const hasRowwithSameAccount = DataTable.filter(x => x.account == strCode && x.code == FormRow.code && x.id != FormRow.id)
    if (hasRowwithSameAccount.length > 0) {
      return false
    }
    return true
  }


  //* End Code Validation   */
  return (
    <tr key={FormRow.id}>
      <td style={{ width: "200px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              maxLength="8"
              id={"provider" + Key}
              value={FormRow.code}
              disabled={Disabled ? true : FormRow.providercCodeDisable}
              onChange={e => {

                let valProvider = Text(
                  e.target,
                  30,
                  true,
                  true,
                  "camel",
                  false
                )

                changeRowValueChanges(valProvider, FormRow.id, "code")
              }}
              onBlur={e => {
                CodeValidation(e.target.value, FormRow.id)
                getData(e.target.value)
              }
              }
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td>
        <Row className="mb-0">
          <Col md="12">
            <Button
              outline
              color="success"
              id={"vasSearch" + Key}
              onClick={clickSearch}
              disabled={Disabled ? true : FormRow.providercCodeDisable}
              size="sm">
              <i
                className="mdi mdi-search-web"
                style={{ fontSize: "12px" }}
              ></i>
            </Button>
          </Col>
        </Row>
      </td>
      <td style={{ width: "300px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Description"
              textType="text"
              maxLength="8"
              id={"desc" + Key}
              value={FormRow.desc}
              disabled={true}
              onChange={(e) => {
                changeRowValueChanges(e.target.value, FormRow.id, "desc")
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "300px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              maxLength="20"
              id={"account" + Key}
              value={FormRow.account}
              disabled={Disabled}
              onChange={(e) => {
                var val1 = Text(e.target, 20, true, true, 'any', false)
                changeRowValueChanges(val1, FormRow.id, "account")
              }}
              onBlur={e => {
                if (AccountValidation(e.target.value, FormRow.id)) {

                } else {
                  AlertShow(true)
                  AlertDesc("This Account number has already used with this Provider !")
                  changeRowValueChanges("", FormRow.id, "account")
                }
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td>
        <Row className="mb-0">
          <Col md="1">
            <Button
              outline
              color="danger"
              id={"vasDelete" + Key}
              onClick={e => {
                RemoveRow(FormRow.id)
              }}
              size="sm"
              disabled={Disabled}
            >
              <i
                className="mdi mdi-delete"
                style={{ fontSize: "12px" }}
              ></i>
            </Button>
          </Col>{" "}

          <DPSearchBoxDynamic
            searchData={[]}
            columns={HeadColumns}
            defaultSorted={defaultSorted}
            mainTitle={"Vas Detail Search"}
            SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
            isOpen={modal_xlarge}
            toggle={tog_xlarge}
            getSelect={Hed_SelectRowSearch}
            APIURL={ApiURL}
            URLPath={"CUSTOMERVAS"}
            MenuCode={menuCode}
            KeyVal={"VAS"}
            searchBy={"VS_CODE"}
            FilterStr={groupFilter}
          />
        </Row>
      </td>
    </tr>
  )
}


